import React, {useState, useEffect} from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useSiteContext} from '../../../contexts/site'

const HeaderBorder = () => {
    const {isYR} = useSiteContext()
    const [scrolling, setScrolling] = useState(false)
    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY
            if (scrollY > 80) {
                setScrolling(true)
            } else {
                setScrolling(false)
            }
        }

        window.addEventListener('scroll', handleScroll)

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <Box
            position="absolute"
            bottom="0"
            width="100%"
            borderBottom="0.5px solid"
            marginRight="-0.5rem"
            sx={{
                borderImageSlice: {
                    base: isYR && scrolling ? 0 : 1,
                    lg: 'linear-gradient(90deg, var(--chakra-colors-gray-450) 0%, var(--chakra-colors-gray-850) 100%)'
                },
                borderImageSource:
                    'linear-gradient(90deg, var(--chakra-colors-gray-450) 0%, var(--chakra-colors-gray-850) 100%)'
            }}
        />
    )
}

export default HeaderBorder
